// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3bc_R","left":"StickyBox_left__3xR7_","right":"StickyBox_right__3ZM_D"};